import { debounceTime, filter, first, map, withLatestFrom } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';
import { merge, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { DocumentEventsService } from '../document-events.service';
import { StateService } from '../state/state.service';
import { ToasterService } from '../toaster.service';
import {EventBusChunkAwareErrorHandler} from "./event-bus-chunk-aware-error-handler.service";

export const ERROR_DEBOUNCE_TIME = 250;

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {
  private translate = inject(TranslateService);
  private toaster = inject(ToasterService);
  private auth = inject(AuthService);
  private state = inject(StateService);
  private errorEventBus = inject(EventBusChunkAwareErrorHandler);
  private documentEvents = inject(DocumentEventsService);

  public init() {
    merge(this.errorEventBus.error$.pipe(debounceTime(ERROR_DEBOUNCE_TIME)),
      this.documentEvents.ledgerEvent$.pipe(filter(e => e.params.event === 'error'),
        map(e => ({
          status: (e.params && e.params.code) ? e.params.code : 500,
        }))))
      .subscribe(e => this.handleError(e));
  }

  public handleError(body) {
    switch (body.status) {
      case 401:
        this.state.mobileApp$.pipe(
          withLatestFrom(this.auth.isLoggedIn$),
          first())
          .subscribe(([mobileApp, isLoggedIn]) => {
            if (mobileApp) {
              const baseUrl = window.location.href.split('#')[0];
              window.location.href = baseUrl + 'logout-for-mobile';
            } else {
              if (isLoggedIn) {
                body.errorMessage = this.translate.instant('ERROR_MESSAGES.' + body.status);
                this.toaster.pop('error', body.errorMessage, '');
              }
              this.auth.logout();
            }
          });

        break;
    }
  }
}
